import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslocoService } from "@ngneat/transloco";
import { paremetersForRedirectUrl } from "app/services/marketing/marketing-parameters";
import { Observable, ReplaySubject, switchMap } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class MarketingGuestService {

    private _marketingGuestRedirectUrlData: ReplaySubject<any> = new ReplaySubject<any>(1);

    constructor(
        private router: ActivatedRoute,
        private translocoService: TranslocoService
    ) { }

    get marketingGuestDRedirectUrlata$(): Observable<any> {
        return this._marketingGuestRedirectUrlData.asObservable();
    }

    setMarketingGuestDRedirectUrlata() {
        let activeLang;
        this.translocoService.langChanges$.pipe(switchMap(lang => {
            activeLang = lang
            return this.router.queryParams
        }))
            .subscribe(res => {
                if (res?.redirectURL) {
                    let page = res.redirectURL.replace('/', '');
                    if (paremetersForRedirectUrl[activeLang] && paremetersForRedirectUrl[activeLang][page]) {
                        let defaultParameters = structuredClone(paremetersForRedirectUrl['default']);
                        this._marketingGuestRedirectUrlData.next(Object.assign(defaultParameters, paremetersForRedirectUrl[activeLang][page]));
                    }
                    else this._marketingGuestRedirectUrlData.next(paremetersForRedirectUrl['default']);

                }
            });

    }

} 